import { render, staticRenderFns } from "./FormEditarProveedor.vue?vue&type=template&id=b2f338c0&scoped=true&"
import script from "./FormEditarProveedor.vue?vue&type=script&lang=ts&"
export * from "./FormEditarProveedor.vue?vue&type=script&lang=ts&"
import style0 from "./FormEditarProveedor.vue?vue&type=style&index=0&id=b2f338c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f338c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('b2f338c0', component.options)
    } else {
      api.reload('b2f338c0', component.options)
    }
    module.hot.accept("./FormEditarProveedor.vue?vue&type=template&id=b2f338c0&scoped=true&", function () {
      api.rerender('b2f338c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Proveedores/FormEditarProveedor.vue"
export default component.exports